// Loads which ngtorch the plans on screen ran with (see utils/ngtorchRuns.js). The component lists them
// as `ngtorchRunsPlans`, plan objects plus the clientId of their model, and reads them back with
// ngtorchPlanOverride and ngtorchBudgetSimulationOverrides. Only admins and scientists in dev load
// anything.

import {
  ngtorchRunsVisible,
  createdMillis,
  loadOverriddenRuns,
  planOverride,
  budgetSimulationOverrides
} from '@/utils/ngtorchRuns.js'

export const ngtorchRuns = {
  computed: {
    ngtorchRunsVisible () {
      return ngtorchRunsVisible(this.$store.getters['auth/authUser'])
    },
    // A plan's queue item appears a moment after the plan, and an edit gives it a new one, so the
    // runs are read again when a plan is added, edited or gets its results.
    ngtorchRunsKey () {
      if (!this.ngtorchRunsVisible) return ''
      return (this.ngtorchRunsPlans || [])
        .map(plan => `${plan.clientId}/${plan.id}/${createdMillis(plan.date_created)}/${Boolean(plan.results || plan.hasResults)}`)
        .join(',')
    }
  },
  watch: {
    ngtorchRunsKey: {
      handler (key) {
        if (!key) return
        const clientIds = []
        this.ngtorchRunsPlans.forEach(plan => {
          if (plan.clientId && clientIds.indexOf(plan.clientId) === -1) clientIds.push(plan.clientId)
        })
        clientIds.forEach(clientId => loadOverriddenRuns(clientId, true))
      },
      immediate: true
    }
  },
  methods: {
    ngtorchPlanOverride (clientId, plan) {
      return this.ngtorchRunsVisible ? planOverride(clientId, plan) : null
    },
    ngtorchBudgetSimulationOverrides (clientId, budgetSimulationId) {
      return this.ngtorchRunsVisible ? budgetSimulationOverrides(clientId, budgetSimulationId) : []
    },
    // One entry per grid point that has run: its override, or null when it used the image's ngtorch.
    // A point with neither results nor an override may simply not have been queued yet.
    ngtorchPointsOverrides (clientId, points) {
      if (!this.ngtorchRunsVisible) return []
      const overrides = []
      points.forEach(point => {
        const override = planOverride(clientId, point)
        if (override || point.results) overrides.push(override)
      })
      return overrides
    }
  }
}
